import PropTypes from 'prop-types';


export default {
  dispatch: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  validationMessage: PropTypes.string.isRequired,
  markedAsWrong: PropTypes.bool.isRequired,
  focus: PropTypes.bool.isRequired,
  apiError: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  suggestions: PropTypes.arrayOf(PropTypes.object).isRequired
};
